<template>
<div class="left-menu" :class="{ 'active-menu': isCollapse }">
  <div class="title" @click="toSystem">{{ isCollapse ? logo : title }}</div>
  <el-menu :default-active="defaultActive" :default-openeds="defaultOpeneds" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="handleSelect" :collapse="isCollapse" background-color="#1e282c" text-color="#fff" active-text-color="#ffd04b">
    <span v-for="(item, index) in menuList" :key="index">
      <el-menu-item v-if="!item.children" :index="item.name">
        <i :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
      <el-submenu v-else :index="item.name">
        <template slot="title">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.title }}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item style="padding-left: 60px;" :index="citem.name" v-for="(citem, cindex) in item.children" :key="cindex">{{ citem.title }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </span>
  </el-menu>
</div>
</template>

<script>
import website from '@/utils/website.js';
import {
  getInfo
} from '@/utils/auth.js'
export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: '',
      logo: '',
      defaultOpeneds: ['GroupConfig'],
      menuList: []
    };
  },
  methods: {
    toSystem() {
      this.$router.push({
        path: '/system'
      })
    },
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
    handleSelect(key, keyPath) {
      let allNode = this.COMM.getAllNode(this.menuList);
      let node = {};
      allNode.forEach((item, index) => {
        if (item.name == key) {
          node = item;
        }
      });
      this.$emit('select', node);
    },
    myFilter(data) {
      if (data == null || data == undefined || data.length == 0) {
        return
      } else {
        for (let index = data.length - 1; index >= 0; index--) {
          console.log(data[index], '菜单1')
          // 删除状态2的元素,且不为过渡结点的元素
          if (data[index].resourceType != 4) {
            data.splice(index, 1)
          } else {
            let address = data[index].routingAddress;
            address = address.split('|');
            data[index].name = data[index].componentName;
            data[index].title = data[index].resourceNameShow;
            data[index].path = address[0];
            data[index].icon = data[index].icon;
            console.log(data[index], '菜单')
            if (data[index].children.length == 0) {
              delete data[index].children
            }
          }
        }
      }
    },
    filterData(data) {
      // 到叶子节点了，返回,递归出口
      if (data == undefined || data == null || data.length == 0) {
        console.log('return')
        return
      } else {
        // 对每一层，遍历这个数组，调用filterData方法对每个元素下的数组进行同样的操作
        // 筛掉当前层的status为2的对象
        this.myFilter(data)
        for (let index in data) {
          this.filterData(data[index].children)
          if (data[index].children == 0) {
            delete data[index].children;
          }
        }
      }
    }
  },
  computed: {
    defaultActive() {
      return this.$route.name;
    }
  },
  created() {
    this.title = 'BOSS后台管理系统';
    this.logo = website.logo;
    this.menuList = this.COMM.getMenuList();
  }
};
</script>

<style lang="scss" scoped>
$menuWidth: 320px;
$color: #1e282c;

.left-menu {
  width: $menuWidth;
  min-width: $menuWidth;
  height: 100%;

  .title {
    height: 56px;
    line-height: 56px;
    text-align: center;
    width: 100%;
    font-size: 24px;
    font-weight: bold;
    background-color: #1e282c;
    color: #ffffff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    box-shadow: inset 0px 0px 1px #888888;

    &:hover {
      cursor: pointer;
    }
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
    height: calc(100% - 56px);
    border: 0px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-menu--collapse {
    height: 100%;
  }
}

.active-menu {
  width: 64px;
  min-width: auto;

  .el-menu--collapse {
    .el-submenu {
      .el-submenu__title {
        span {
          display: none;
        }
      }
    }
  }
}
</style>
<style>
.el-menu-item [class^='iconfont'] {
  width: 24px;
  text-align: center;
  font-size: 16px;
}
.el-menu-item [class^='el-icon-'] {
  width: 16px !important;
  text-align: center;
  font-size: 16px;
}

.icon-sjpz1 {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 16px;
}

.el-menu-item * {
  margin-right: 5px !important;
  vertical-align: revert !important;
}

.el-submenu__title * {
  margin-right: 5px !important;
  vertical-align: revert !important;
}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu.vue